(function (Drupal) {
  Drupal.behaviors.performanceGrid = {
    attach(context) {
      const filterGroups = context.querySelectorAll('.filter-group');
      const rows = context.querySelectorAll('.views-row');

      /* ---------- helpers ---------- */
      const readFiltersFromURL = () => {
        const params = new URLSearchParams(location.search);
        const map = new Map();
        filterGroups.forEach(g => {
          const name = g.dataset.filterName;
          map.set(name, params.get(name) || 'all');
        });
        return map;
      };

      const writeFiltersToURL = map => {
        const params = new URLSearchParams(location.search);
        map.forEach((val, key) => {
          val === 'all' ? params.delete(key) : params.set(key, val);
        });
        history.replaceState(null, '', `${location.pathname}?${params}`);
      };

      const applyFilters = map => {
        let visible = 0;
        rows.forEach(row => {
          const perf = row.querySelector('.node.is-type-performance');
          if (!perf) return;

          const show = Array.from(map).every(
              ([name, val]) => val === 'all' || perf.dataset[name] === val
          );
          row.style.display = show ? '' : 'none';
          if (show) visible++;
        });

        /* ----- no-results message ----- */
        let msg = context.querySelector('.performance-no-results');
        if (!visible) {
          if (!msg) {
            msg = document.createElement('p');
            msg.className = 'performance-no-results';
            msg.textContent = Drupal.t('No performances match your filters.');
            rows[0]?.parentElement?.prepend(msg);
          }
          msg.style.display = 'block';
        } else if (msg) {
          msg.style.display = 'none';
        }
      };

      /* ---------- init ---------- */
      const activeFilters = readFiltersFromURL();

      /* restore active markers */
      filterGroups.forEach(group => {
        const name  = group.dataset.filterName;
        const value = activeFilters.get(name);
        group.querySelectorAll('.filter-link').forEach(link => {
          if (link.dataset.filterValue === value) {
            link.classList.add('active');
          }
        });
      });

      applyFilters(activeFilters);

      /* ---------- listeners ---------- */
      filterGroups.forEach(group => {
        const name = group.dataset.filterName;
        group.querySelectorAll('.filter-link').forEach(link => {
          link.querySelector('a').addEventListener('click', e => {
            e.preventDefault();

            /* update active marker */
            group.querySelectorAll('.filter-link').forEach(l =>
                l.classList.remove('active')
            );
            link.classList.add('active');

            /* store choice */
            activeFilters.set(name, link.dataset.filterValue);
            writeFiltersToURL(activeFilters);
            applyFilters(activeFilters);
          });
        });
      });
    }
  };
})(Drupal);
